import { useState, useEffect } from 'react'
import { isEmpty } from 'lodash'
import { Form } from '@enterprise-ui/canvas-ui-react'
import { getNewDpcisFromString } from './helper'
import { SEARCH_TEXT } from '../../../../searchConstants'

export const DpciFilterComponent = (filter) => {
  const {
    id: filterId,
    name,
    onFilterChange,
    selectedValue,
    setSelectedValues,
  } = filter

  const [errorState, setErrorState] = useState('')
  // eslint-disable-next-line no-unused-vars
  const [resetString, setResetString] = useState('')

  const validate = (value) => {
    const dpciResult = getNewDpcisFromString(value)
    const validDpcis = dpciResult.valid.map((dpci) => ({
      value: dpci,
      displayValue: dpci,
    }))
    const resetStringLocal = dpciResult.invalid

    const isValid = dpciResult?.invalid?.length === 0
    setErrorState(!isValid)

    onFilterChange(filterId, !isEmpty(validDpcis) ? validDpcis : null)
    setResetString(resetStringLocal?.join())
  }
  const handleUpdate = (e) => {
    const newValue = e.target.value
    setSelectedValues((prev) => ({ ...prev, [filterId]: newValue }))
    validate(newValue)
  }

  useEffect(() => {
    // Validate the initial selectedValue on component mount
    if (selectedValue) {
      validate(selectedValue)
    } else {
      setSelectedValues((prev) => ({ ...prev, [filterId]: '' }))
      setErrorState(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedValue])

  return (
    <Form.Field
      id={`${filterId}-filter`}
      label={name}
      className={errorState ? 'dpci_filter' : ''}
      placeholder={name}
      type="text"
      error={errorState}
      errorText={SEARCH_TEXT.ERROR_TEXT.DPCI_ERROR}
      value={selectedValue}
      onChange={(e) => handleUpdate(e)}
    />
  )
}
